import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { FulfillmentOrderImageService } from 'common/data';

class FulfillmentOrderImageStore extends BaseStore {
	constructor(rootStore) {
		super(new FulfillmentOrderImageService(rootStore.app.baasic.apiClient));
	}

	@action
	async getImages(fulfillmentOrderId) {
		const response = await this.service.getImages(fulfillmentOrderId);
		this.response = response.data;
		return this.response;
	}
}

export default FulfillmentOrderImageStore;
